import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_chapter_wide_screen_msg = _resolveComponent("chapter-wide-screen-msg");
  const _component_simple_quiz = _resolveComponent("simple-quiz");
  const _component_Slide = _resolveComponent("Slide");
  const _component_quiz_viewer_carousel = _resolveComponent("quiz-viewer-carousel");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_quiz_viewer_layout = _resolveComponent("quiz-viewer-layout");
  return _ctx.quiz ? (_openBlock(), _createBlock(_component_quiz_viewer_layout, {
    key: 0,
    "center-content": _ctx.quizCompleted
  }, {
    content: _withCtx(() => [_ctx.quizCompleted ? (_openBlock(), _createBlock(_component_chapter_wide_screen_msg, {
      key: 0,
      icon: "format-list-checkbox",
      message: _ctx.$t('view.speach.simpleQuiz.quizCompletedMsg')
    }, null, 8, ["message"])) : (_openBlock(), _createBlock(_component_quiz_viewer_carousel, {
      key: 1,
      ref: "simpleQuizViewerCarousel",
      onSlideEnd: _ctx.onSlideChange
    }, {
      slides: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayableQuestions, (question, index) => {
        return _openBlock(), _createBlock(_component_Slide, {
          key: index
        }, {
          default: _withCtx(() => [_createVNode(_component_simple_quiz, {
            question: question,
            "quiz-nb-questions": _ctx.displayableQuestions.length,
            "correct-answers-ids": _ctx.correctAnswersIds,
            "is-result-mode": _ctx.currentQuestionIndex === index && _ctx.displayNextQuestionButton,
            "answers-approval-state": _ctx.answersApprovalState,
            onAnswerChange: _ctx.onQuizAnswerChange
          }, null, 8, ["question", "quiz-nb-questions", "correct-answers-ids", "is-result-mode", "answers-approval-state", "onAnswerChange"])]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    }, 8, ["onSlideEnd"]))]),
    footer: _withCtx(() => [_ctx.answersApprovalState === false ? (_openBlock(), _createBlock(_component_standard_button, {
      key: 0,
      class: "footer-button",
      outlined: true,
      label: _ctx.$t('view.speach.simpleQuiz.correctionButton'),
      onAction: _ctx.onCorrectionButtonClick
    }, null, 8, ["label", "onAction"])) : _createCommentVNode("", true), !_ctx.shouldDisplayConfirmButton ? (_openBlock(), _createBlock(_component_standard_button, {
      key: 1,
      class: "footer-button",
      disabled: !_ctx.userHasAnswered,
      label: _ctx.$t('view.speach.simpleQuiz.confirmButton'),
      onAction: _ctx.onConfirmButtonClick
    }, null, 8, ["disabled", "label", "onAction"])) : _createCommentVNode("", true), _ctx.displayNextQuestionButton ? (_openBlock(), _createBlock(_component_standard_button, {
      key: 2,
      class: "footer-button",
      label: _ctx.$t('view.speach.simpleQuiz.nextButton'),
      onAction: _ctx.onNextStepButtonClick
    }, null, 8, ["label", "onAction"])) : _createCommentVNode("", true), _ctx.quizCompleted ? (_openBlock(), _createBlock(_component_standard_button, {
      key: 3,
      class: "footer-button",
      outlined: true,
      label: _ctx.$t('view.speach.simpleQuiz.restartButton'),
      onAction: _ctx.onRestartButtonClick
    }, null, 8, ["label", "onAction"])) : _createCommentVNode("", true), _ctx.quizCompleted && (_ctx.isLocked || !_ctx.isLastChapter) ? (_openBlock(), _createBlock(_component_standard_button, {
      key: 4,
      class: "footer-button",
      label: _ctx.$t('view.speach.simpleQuiz.doneButton'),
      onAction: _ctx.onQuizDoneButtonClick
    }, null, 8, ["label", "onAction"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["center-content"])) : _createCommentVNode("", true);
}